/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
// assets
import StyledStep from './styles';

const Step = (props) => {
  const { step, position, isMobileDevice } = props;

  return (
    <StyledStep active={step.state.active}>
      <article className="cont-step-number pt-md-2 ml-md-2">
        <div className="font-size-18 font-weight-bold">{position}</div>
      </article>
      <section>
        <article>
          {step.state.active && <span className="font-size-18">{step.state.text}</span>}
          <h2>{step.title}</h2>
        </article>
        {step.content}
      </section>
      {!isMobileDevice && (
        <article className="cont-step-img">
          <div>
            <img src={step.icon} alt="icon-step" width="60px" height="60px" />
          </div>
        </article>
      )}
    </StyledStep>
  );
};

Step.defaultProps = {};
Step.propTypes = {};

export default Step;
